module.exports = __webpack_public_path__ + "index/img/fenlei.fdc5944e.png";